import axiosConfig from "./axiosConfig";
import { SiteIngestionConfig, SiteIngestionResponse } from "./getSiteIngestion";

export type PutSiteIngestionRequest = Omit<
  SiteIngestionConfig,
  "site_id" | "created_at" | "updated_at"
>;

const putSiteIngestion = async (
  authToken: string,
  siteId: string,
  request: PutSiteIngestionRequest
): Promise<SiteIngestionResponse> => {
  const { data } = await axiosConfig.put(
    `/site/${siteId}/ingestion`,
    { site: request },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default putSiteIngestion;
